import { __extends } from "tslib";
import { AssetBase } from '@awayjs/core';
import { MethodEvent } from '../events/MethodEvent';
/**
 * MethodBase provides an abstract base method for shading methods, used by compiled passes to compile
 * the final shading program.
 */
var MethodBase = /** @class */ (function (_super) {
    __extends(MethodBase, _super);
    /**
     * Create a new MethodBase object.
     */
    function MethodBase() {
        var _this = _super.call(this) || this;
        _this._textures = new Array();
        _this._owners = new Array();
        _this._counts = new Array();
        return _this;
    }
    /**
     * Cleans up any resources used by the current object.
     */
    MethodBase.prototype.dispose = function () {
    };
    MethodBase.prototype.iAddOwner = function (owner) {
        //a method can be used more than once in the same material, so we check for this
        var index = this._owners.indexOf(owner);
        if (index != -1) {
            this._counts[index]++;
        }
        else {
            this._owners.push(owner);
            this._counts.push(1);
            //add textures
            var len = this._textures.length;
            for (var i = 0; i < len; i++)
                owner.addTexture(this._textures[i]);
        }
    };
    MethodBase.prototype.iRemoveOwner = function (owner) {
        var index = this._owners.indexOf(owner);
        if (this._counts[index] != 1) {
            this._counts[index]--;
        }
        else {
            this._owners.splice(index, 1);
            this._counts.splice(index, 1);
            //remove textures
            var len = this._textures.length;
            for (var i = 0; i < len; i++)
                owner.removeTexture(this._textures[i]);
        }
    };
    /**
     *
     */
    MethodBase.prototype.iAddTexture = function (texture) {
        this._textures.push(texture);
        var len = this._owners.length;
        for (var i = 0; i < len; i++)
            this._owners[i].addTexture(texture);
    };
    /**
     *
     */
    MethodBase.prototype.iRemoveTexture = function (texture) {
        this._textures.splice(this._textures.indexOf(texture), 1);
        var len = this._owners.length;
        for (var i = 0; i < len; i++)
            this._owners[i].removeTexture(texture);
    };
    /**
     * Marks the shader program as invalid, so it will be recompiled before the next render.
     *
     * @internal
     */
    MethodBase.prototype.invalidateShaderProgram = function () {
        this.invalidate();
        this.dispatchEvent(new MethodEvent(MethodEvent.SHADER_INVALIDATED));
    };
    /**
     * Copies the state from a MethodBase object into the current object.
     */
    MethodBase.prototype.copyFrom = function (method) {
    };
    return MethodBase;
}(AssetBase));
export { MethodBase };
import { AbstractionBase } from '@awayjs/core';
import { ChunkVO } from '@awayjs/renderer';
/**
 * _Shader_MethodBase provides an abstract base method for shading methods, used by compiled passes to compile
 * the final shading program.
 */
var _Shader_MethodBase = /** @class */ (function (_super) {
    __extends(_Shader_MethodBase, _super);
    function _Shader_MethodBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.chunkVO = new ChunkVO();
        return _this;
    }
    /**
     * Create a new _Shader_MethodBase object.
     */
    _Shader_MethodBase.prototype.init = function (method, shader) {
        _super.prototype.init.call(this, method, shader);
    };
    _Shader_MethodBase.prototype._isUsed = function () {
        return true;
    };
    _Shader_MethodBase.prototype._usesTangentSpace = function () {
        return true;
    };
    /**
     * Initializes the properties for a MethodVO, including register and texture indices.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._initVO = function (chunkVO) {
    };
    /**
     * Initializes unchanging shader constants using the data from a MethodVO.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._initConstants = function () {
    };
    /**
     * Resets the compilation state of the method.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._reset = function (chunkVO) {
        this._invalid = true;
        chunkVO.useChunk = false;
        chunkVO.needsProjection = false;
        chunkVO.needsView = false;
        chunkVO.needsNormals = false;
        chunkVO.needsTangents = false;
        chunkVO.needsGlobalVertexPos = false;
        chunkVO.needsGlobalFragmentPos = false;
        this._cleanCompilationData();
    };
    /**
     * Resets the method's state for compilation.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._cleanCompilationData = function () {
    };
    /**
     * Get the vertex shader code for this method.
     * @param vo The MethodVO object linking this method with the pass currently being compiled.
     * @param regCache The register cache used during the compilation.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._getVertexCode = function (registerCache, sharedRegisters) {
        return '';
    };
    /**
     * @inheritDoc
     */
    _Shader_MethodBase.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        return '';
    };
    /**
     * Sets the render state for this method.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     * @param stage The Stage object currently used for rendering.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._activate = function () {
    };
    /**
     * Sets the render state for a single renderable.
     *
     * @param vo The MethodVO object linking this method with the pass currently being compiled.
     * @param renderable The renderable currently being rendered.
     * @param stage The Stage object currently used for rendering.
     * @param camera The camera from which the scene is currently rendered.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._setRenderState = function (renderState) {
    };
    /**
     * Clears the render state for this method.
     * @param vo The MethodVO object linking this method with the pass currently being compiled.
     * @param stage The Stage object currently used for rendering.
     *
     * @internal
     */
    _Shader_MethodBase.prototype._deactivate = function () {
        this._invalid = false;
    };
    return _Shader_MethodBase;
}(AbstractionBase));
export { _Shader_MethodBase };
